import React, { FC, useEffect, useState } from "react";
import OwnerLayout from "../../components/layouts/OwnerLayout";
import styled from "styled-components";
import HeaderOne from "../../components/parts/HeaderOne";
import {
  GetOwnerDraftShops200ResponseInner,
  GetOwnerShops200ResponseInner,
} from "../../../api/v1";
import { api } from "../../../api";
import { captureException } from "@sentry/react";
import OwnerShopList from "../../components/combinations/Owner/OwnerShopList";
import UserHead from "../../config/UserHead";
import OwnerDraftShopList from "../../components/combinations/Owner/OwnerDraftShopList";

const OwnerShopsStyle = styled.div`
  background: white;
  border-radius: 25px;
  padding: 20px 0;
  margin: 30px;

  @media (max-width: 767px) {
    margin: 30px 10px;
  }
`;

const OverviewStyle = styled.div`
  margin: 0 30px;

  @media (max-width: 767px) {
    margin: 0 10px 10px 10px;
  }
`;

const Dashboard: FC = () => {
  const [shops, setShop] = useState<GetOwnerShops200ResponseInner[]>([]);
  const [draftShops, setDraftShops] = useState<
    GetOwnerDraftShops200ResponseInner[]
  >([]);

  useEffect(() => {
    api
      .getOwnerShops()
      .then((response) => {
        setShop(response.data);
      })
      .catch((error) => {
        if (error.response?.status === 401) return;
        captureException(error);
      });
  }, []);

  useEffect(() => {
    api
      .getOwnerDraftShops()
      .then((response) => {
        setDraftShops(response.data);
      })
      .catch((error) => {
        if (error.response?.status === 401) return;
        captureException(error);
      });
  }, []);

  return (
    <OwnerLayout>
      <UserHead title="オーナー店舗情報" />
      <OwnerShopsStyle>
        <OverviewStyle>
          <HeaderOne>オーナー店舗情報</HeaderOne>
        </OverviewStyle>
        <OwnerShopList shops={shops} />
      </OwnerShopsStyle>
      <OwnerShopsStyle>
        <OverviewStyle>
          <HeaderOne>追加申請中の店舗</HeaderOne>
        </OverviewStyle>
        <OwnerDraftShopList shops={draftShops} />
      </OwnerShopsStyle>
    </OwnerLayout>
  );
};
export default Dashboard;
